import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Stack from 'react-bootstrap/Stack';

import AddressAutocomplete from 'components/formElements/AddressAutocomplete';
import InfoBox from 'components/formElements/InfoBox';

import IconConfigurator from 'assets/images/icon_configurator.svg';
import BackgroundDefault from 'assets/images/produkte-e3dc-2026.png';
import BackgroundMaps from 'assets/images/background_maps.png';

const AddressSelection = () => {

    const backgroundStyle = {
        background: `url(${BackgroundDefault}) no-repeat`,
        backgroundSize: '100%',
        backgroundPosition: 'right bottom',
    };

    const mapBackgroundStyle = {
        background: `url(${BackgroundMaps}) no-repeat`,
        backgroundSize: 'cover'
    };

    return (
        <Row className="full-height">
            <Col className="text-center d-flex" style={backgroundStyle}>
                <div>
                    <Stack gap={3} className="ContainerPadding">
                        <img src={IconConfigurator} alt="E3/DC Konfigurator" height="65"/>
                        <h1>Ihren Stromspeicher konfigurieren</h1>
                        <div>Bitte geben Sie Ihre Adresse ein und fokussieren Sie Ihre Liegenschaft auf
                            dem Kartenausschnitt.</div>
                        <AddressAutocomplete/>
                    </Stack>
                </div>
            </Col>
            <Col className="backgroundMaps mapContainerWrapper d-flex justify-content-center align-items-end" style={mapBackgroundStyle}>
                <InfoBox>Die Angaben zu Autarkiegraden/Installierter Solarleistung/genutzter PV Fläche/Stromerzeugung usw. sind Schätzwerte auf Basis unserer Erfahrungen und stellen keine garantierten Ergebnisse dar. Im Rahmen der Planung ihrer Anlage wird eine detailliertere Schätzung erstellt</InfoBox>
            </Col>
        </Row>
    )
}

export default AddressSelection;